import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse} from "../../../../types";
import {IElectiveCreate, IElectivePayload} from "../types";
import {
    deletedElective,
    deletedRestoreElective,
    setElective,
    setElectiveStudent,
    setRestoreElective,

} from "./electiveSlice";
import { renderErrorMessages } from "@utils/renderErrorMessages";
import { getErrorMessages } from "@utils/getErrorMessages";
import { IBaseError } from "types";
import { t } from "i18next" ;

const GetElective = createAsyncThunk(
    "get/elective",
    async (_, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.get("/elective-subject");
            dispatch(setElective(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const SetElective = createAsyncThunk(
    "create/elective",
    async ( data : IElectiveCreate) => {
        try {
            const response = await request.post("/elective-subject", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            renderErrorMessages(
                getErrorMessages(
                    typedError.response.data as unknown as IBaseError
                ),
                t
            );

        }
    }
);

const DeleteElective = createAsyncThunk(
    "delete/elective",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/elective-subject/${id}`);
            dispatch(deletedElective(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditElective = createAsyncThunk(
    "edit/elective",
    async ( data : IElectivePayload, { rejectWithValue }) => {
        try {
            const response = await request.put(`/elective-subject/${data.id}`, data);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const GetDeleteElective = createAsyncThunk(
    "get/delete/elective",
    async (_, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.get(`/elective-subject/deleted-items`);
            dispatch(setRestoreElective(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const RestoreDeleteElective = createAsyncThunk(
    "restore/delete/elective",
    async (id: number, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.post(`/elective-subject/restore/${id}`);
            dispatch(deletedRestoreElective(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);



const GetItemElective = createAsyncThunk(
    "get/item/elective",
    async (id: number, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.get(`/elective-subject/${id}`)
            dispatch(setElectiveStudent(response.data))
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);



export{
    GetElective,
    SetElective,
    DeleteElective,
    EditElective,
    RestoreDeleteElective,
    GetDeleteElective,
    GetItemElective

}
